import { Stack } from '@mui/material'
import { TestParameter } from '../../../../types/TestParameter'
import { TestParameterPicker } from './TestParameterPicker'

interface TestParametersContainerProps {
  parameters: TestParameter[]
  selectedValues: Record<string, number>
  onValueSelect: (parameterName: string, value: number) => void
}

export const TestParametersContainer = ({
  parameters,
  selectedValues,
  onValueSelect,
}: TestParametersContainerProps) => {

  return (
    <Stack 
      spacing={2} 
      sx={{ 
        maxWidth: 800, 
        mx: 'auto', 
        pb: { xs: 12, md: 12, lg: 2 },
        width: '100%',
      }}
    >
      {parameters.map((parameter, index) => (
        <TestParameterPicker
          key={parameter.name}
          parameter={parameter}
          selectedValue={selectedValues[parameter.name]}
          onValueSelect={(value) => onValueSelect(parameter.name, value)}
          index={index}
        />
      ))}
    </Stack>
  )
} 